var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"apitest"}},[_vm._v(" ApiTest"),_c('br'),_c('h2',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "+_vm._s(_vm.data.alt)+" "),_c('br'),_c('img',{attrs:{"src":_vm.data.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }